(() => {
 const init = () => {
  const hero = document.querySelector('.ks-weights-head ks-product');
  if (hero) {
   const sync = variant => {
    const split = hero.querySelector('[data-ks-split-shipping]');
    if (split) split.hidden = !/set/i.test(variant?.title || '');
   };
   hero.addEventListener('variant:change', e => sync(e.detail.variant));
   document.querySelectorAll('[data-ks-weight-choice]').forEach(button => button.addEventListener('click', () => {
    hero.selectVariant(button.dataset.ksWeightChoice, true);
    hero.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
   }));
  }
  const story = document.querySelector('.ks-weights-story');
  if (!story) return;
  // Preserve older lazy video modules after their purchase-area script is retired.
  story.querySelectorAll('video[data-src]').forEach(video => {
   video.controls = true;
   if (!video.getAttribute('src') && !video.querySelector('source')) video.src = video.dataset.src;
  });
  story.querySelectorAll('[data-video-toggle]').forEach(button => {
   const video = document.getElementById(button.dataset.videoToggle);
   if (!video) return;
   const sync = () => { button.textContent = video.paused ? window.KensuiCopy("9cf00dd1168b64da05","Play video",[]) : window.KensuiCopy("500719e553582aaef4","Pause video",[]); button.setAttribute('aria-pressed', String(!video.paused)); };
   button.addEventListener('click', () => {
    if (!video.paused) { video.pause(); return; }
    video.play().catch(() => {
     const error = video.parentElement.querySelector('[role="status"]');
     if (error) error.hidden = false;
    });
   });
   video.addEventListener('play', sync);
   video.addEventListener('pause', sync);
   sync();
  });
  story.querySelectorAll('table').forEach(table => {
   if (table.closest('.ks-w-table-scroll')) return;
   const wrap = document.createElement('div');wrap.className='ks-w-table-scroll';
   table.before(wrap);wrap.append(table);
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);else init();
})();

